import {
    ContactPhoneNumberModel,
    ContactEmailModel,
    FullAudit,
    IsActiveFlag,
    UserModel,
} from '@/types';

export interface ContactModel extends IsActiveFlag, FullAudit {
    id: number;
    levelId: number;
    name: string;
    phones: ContactPhoneNumberModel[];
    emails: ContactEmailModel[];
    contactCompany: string;
    ownerUserId: number;
    ownerUser: UserModel;
    lastInteraction: string | null;
    lastSentiment: string | null;
    healthScore: ContactHealthScoreModel;
}

export interface ContactHealthScoreModel {
    score: number | null;
    status: string | null;
    trend: number | null;
}
